export const SHOW_PWA_INFO = "showPWAInfo"
